// eslint-disable-next-line import/no-named-default
import { default as MasterUserAccount } from "./UserAccount";

export default MasterUserAccount;
